import React, {useState,useEffect} from "react";
import {useParams} from "react-router-dom"
import Swal from "sweetalert2";
import {ToastContainer,  toast } from 'react-toastify';
import statementService from "../../services/statementService"; 
import moment from "moment";  

function Recovery() {
    const {token} = useParams();
    // const navigate = useNavigate();
    const [sending, setSending] = useState(true)
    const [statement, setStatement] = useState();

    useEffect(() => {
        doLoad();
    }, [token]);

    const doLoad = async () => {
        try {
            if(token !== undefined && token !== null && token !== ''){
                setSending(false);
                const response = await statementService.getStatementByToken(token);
                setStatement(response.data);
            }else{
                Swal.fire({
                    title: 'ERROR',
                    text: 'Token no válido',
                    icon: 'error',
                    confirmButtonText: 'OK',
                    confirmButtonColor: '#f13939'
                })
            }
        } catch (error) {
            Swal.fire({
                title: 'ERROR',
                text: error.response.data.errors[0].detail,
                icon: 'error',
                confirmButtonText: 'OK',
                confirmButtonColor: '#f13939'
            })
            setSending(true);
        } 
    }

    const doSign = async () => { 
        try {
            Swal.fire({
                title: "Atención!",
                text: "Ud. esta seguro que quiere firmar el documento ?",
                icon: "warning",
                showCancelButton: true,
                confirmButtonText: "Firmar",
                confirmButtonColor: "#83766d"
            }).then((result) => {
                if (result.isConfirmed) {
                    statementService.setStatementSignature(token)
                    .then((response) => {
                        toast.success('Documento Firmado!', {
                            position: "top-right",
                            autoClose: 3000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                            theme: "light",
                        })
                        // setPreviewModel(initPreview)
                        // window.location.reload();
                        doLoad();
                    })
                    .catch((error) => {
                        if(error.response.status !== 401){
                            Swal.fire({
                                title: 'Ooops?',
                                text: error.response.data.errors[0].detail,
                                icon: 'error',
                                confirmButtonText: 'OK',
                                confirmButtonColor: '#f13939'
                            })
                        }
                    })
                }
            });
            
        } catch (error) {
            Swal.fire({
                title: 'ERROR',
                text: error.response.data.errors[0].detail,
                icon: 'error',
                confirmButtonText: 'OK',
                confirmButtonColor: '#f13939'
            })
        }
    }

    return (
        <div className="container-fluid flex-grow-1 container-p-y">
            <div className="card">
                <div className="card-body">
                    <div className="d-flex justify-content-center">
                        <img src="/alchemy-logo.svg" alt="alchemy valores logo" className="img-fluid mb-4" style={{width: '15%'}}/>
                    </div>
                    {
                        sending ? (
                            <div className="d-flex justify-content-center">
                                <div className="spinner-border" role="status">
                                    <span className="visually-hidden">Loading...</span>
                                </div>
                            </div>
                        ) : (
                            <>
                                {statement && (
                                    <>
                                    <h2 className="card-title mb-4">{statement.included.swornStatement.name}</h2>
                                    <p className="card-text">
                                        <div className="card-text"
                                        dangerouslySetInnerHTML={{ __html: statement.included.swornStatement.statement}} />

                                    </p>
                                    <div className="d-flex justify-content-center">
                                        {statement.attributes.statement_signature_status_id === 1 && <button className="btn btn-info" onClick={doSign}>Firma de Declaración</button>}
                                        {statement.attributes.statement_signature_status_id === 2 && <span><strong>Declaración firmada: </strong>{moment(statement.attributes.signed_at).format('DD/MM/YYYY HH:mm')} </span>}
                                        {statement.attributes.statement_signature_status_id === 3 && <span><strong>Declaración Cancelada</strong></span>}
                                    </div>
                                </>
                                )}
                            </>
                        )
                    }
                
                </div>
                {/* GLOBEMIND */}
                <footer style={{textAlign: 'right', marginRight: 20,fontSize: 'small', marginTop: '-25px'}}>
                    Power by <a href="https://globemind.com/" target="_blank" style={{color: '#396bad'}} rel="noreferrer" title="GlobeMind Software Distillery">GlobeMind</a>
                </footer>
            </div>
            
            <ToastContainer></ToastContainer>
        </div>
          
      );
}

  
export default Recovery;